import { IconDefinition } from '@fortawesome/fontawesome-common-types';
export class SocialIcon {
    constructor(icon: IconDefinition, link: string) {
        this.icon = icon;
        this.link = link;
    }
    icon: IconDefinition;
    link: string;
}
